import { supabase } from './supabase';

/**
 * Retorna o tenant_id da sessão ativa, extraído dos claims do JWT.
 * Lança erro se não houver sessão ou claim ausente.
 */
export async function getSessionTenantId(): Promise<string> {
  const { data: { session } } = await supabase.auth.getSession();
  const user = session?.user;
  const tenantId =
    (user?.app_metadata?.tenant_id as string | undefined) ??
    (user?.user_metadata?.tenant_id as string | undefined);
  if (!tenantId) throw new Error('tenant_id não encontrado na sessão.');
  return tenantId;
}
